import { TranslationKey } from './../../../../../types/translation/TranslationKey';
import React, { useContext, useMemo, useState } from 'react';
import { FilterProps } from '../../common/filter.util';
import { Divider, Grid } from '@mui/material';
import { DeleteIcon } from '../../../../icons/Delete/DeleteIcon';
import { VentoryColor } from '../../../../util/color.util';
import { t } from '../../../../../types/translation/Translator';
import MultiSelectionList from '../../../common/MultiSelectionList/MultiSelectionList';
import SearchBar from '../../../common/SearchBar/SearchBar';
import { FileContext } from '../../../../../context/FileContext';
import { FileTypeFilter } from '../FileTypeFilter';

interface FileTypeFilterContentProps {
  filter: FileTypeFilter;
  filterProps: FilterProps;
  setFilterProps: (filter: FilterProps) => void;
}

export default function FileTypeFilterContent({ filter, filterProps, setFilterProps }: FileTypeFilterContentProps) {
  const { files } = useContext(FileContext);

  const [textFilter, setTextFilter] = useState<string>('');

  const values = useMemo(() => {
    return new Set(
      [...files.values()]
        .filter(file => !filterProps.fileTypeCategory?.size || filterProps.fileTypeCategory.has(file.fileTypeCategory))
        .filter(file => filter.search(file.fileType, textFilter))
        .map(file => file.fileType),
    );
  }, [textFilter, files, filterProps.fileTypeCategory, filter]);

  const handleChange = (selected: Set<string>) => {
    filterProps.fileType = selected;
    if (!filterProps.fileType?.size) filterProps.fileType = undefined;
    setFilterProps({ ...filterProps });
  };

  const handleRemove = () => {
    filterProps.fileType = undefined;
    setFilterProps({ ...filterProps });
  };

  return (
    <Grid container>
      <Grid item xs={12} className='flex px-3 py-2'>
        <Grid container>
          <Grid item>
            <p className='text-[13px] font-[500] text-gray-500'>{t(TranslationKey.file).singular.label}</p>
          </Grid>
          <Grid item flexGrow={1} display={'flex'} justifyContent={'flex-end'} sx={{ color: VentoryColor.deleteRed }}>
            <Grid item onClick={handleRemove} className='cursor-pointer'>
              <DeleteIcon />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <SearchBar onChange={i => setTextFilter(i)} className='pl-3 pr-4' />
      </Grid>
      <Grid item className='py-3' xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={12}>
        <MultiSelectionList
          selected={filterProps.fileType}
          values={values}
          onChange={handleChange}
          toText={fileType => fileType}
        />
      </Grid>
    </Grid>
  );
}
